/**
 * Old Survey's Groundtruth toolbar
 */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import {
  Button,
  Toolbar,
  Select,
  FormControl,
  MenuItem,
  InputLabel,
  Typography,
  SelectChangeEvent,
} from '@mui/material';
import Prompt from '../layout/Prompt';
import { RootState } from '../../redux/types';
import {
  setSelectedGroundTruth,
  deleteGroundTruth,
} from '../../redux/actions';
import { useAppDispatch } from '../../hooks/reduxHooks';

const GTEditorToolbar: React.FC = () => {
  const dispatch = useAppDispatch();
  const [selectMenuValue, setSelectMenuValue] = useState<string>('');
  const [promptDelete, setPromptDelete] = useState<boolean>(false);
  const allIds = useSelector((state: RootState) => state.groundTruth.allIds);
  const selectedGroundTruth = useSelector(
    (state: RootState) => state.groundTruth.selectedGroundTruth,
  );

  useEffect(() => {
    if (selectedGroundTruth === undefined) {
      setSelectMenuValue('');
    } else {
      setSelectMenuValue(selectedGroundTruth.toString());
    }
  }, [selectedGroundTruth]);

  const onGroundtruthChange = (event: SelectChangeEvent<string>): void => {
    const selectedGt = event.target.value as string;
    if (selectedGt === '') {
      return;
    }
    dispatch(setSelectedGroundTruth(Number(selectedGt)));
  };

  const onAddGroundtruth = () => {
    dispatch(setSelectedGroundTruth());
  };

  const onDeleteGroundtruth = () => {
    setPromptDelete(true);
  };

  const onConfirmDelete = (confirm: boolean) => {
    if (!confirm) {
      setPromptDelete(false);
      return;
    }
    if (!selectedGroundTruth) {
      return;
    }
    const newSelected = allIds.filter((id) => id !== selectedGroundTruth)[0];
    dispatch(deleteGroundTruth(selectedGroundTruth));
    dispatch(setSelectedGroundTruth(newSelected));
    setPromptDelete(false);
  };

  return (
    <>
      <Toolbar disableGutters>
        <Typography variant="h5" style={{ flexGrow: 1 }}><FormattedMessage id="groundtruthview.manageGroundtruth" /></Typography>
        <FormControl sx={{ m: 2, minWidth: 140 }} size="small">
          <InputLabel id="demo-simple-select-helper-label"><FormattedMessage id="groundtruthNo" /></InputLabel>
          <Select
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            value={selectMenuValue}
            onChange={onGroundtruthChange}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {
              allIds && allIds.map((gtId: number) => (
                <MenuItem key={gtId} value={gtId}>{gtId}</MenuItem>
              ))
            }
          </Select>
        </FormControl>
        <FormControl>
          <Button variant="outlined" color="secondary" onClick={onDeleteGroundtruth}><FormattedMessage id="genericDelete" /></Button>
        </FormControl>
        <FormControl>
          <Button sx={{ ml: 1 }} variant="outlined" onClick={onAddGroundtruth}><FormattedMessage id="add" /></Button>
        </FormControl>
      </Toolbar>
      <Prompt
        display={promptDelete}
        action={onConfirmDelete}
        title="Delete GroundTruth"
      >
        {
          selectedGroundTruth ? (
            <>
              <FormattedMessage id="groundtruthview.deleteConfirm" />
              <br />
              <b>
                Groundtruth:&nbsp;
                {selectedGroundTruth}
              </b>
            </>
          ) : (
            <FormattedMessage id="groundtruthview.selectDelete" />
          )
        }
      </Prompt>
    </>
  );
};

export default GTEditorToolbar;
